import { logD } from "@blacknut/logging/dist";
import { useSpatialNavigation } from "@blacknut/spatialnav-sdk/dist";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const useSpatialNavigationDisabler = () => {
  const history = useHistory();
  const { pause: pauseSpatialNav } = useSpatialNavigation();

  useEffect(() => {
    const unreg2 = history.block((targetLocation) => {
      if (targetLocation && history.location.pathname !== targetLocation.pathname) {
        logD("Spatial", "Pause");
        pauseSpatialNav();
      }
    });

    return () => {
      unreg2();
    };
  }, [history, pauseSpatialNav]);
};
export { useSpatialNavigationDisabler };
